<script setup lang="ts">

    import { defineProps, defineEmits, reactive, ref, onMounted, computed } from "vue";

    const emit = defineEmits(["uploaded"])
    const props = defineProps({
        id: { type: String, required: true },
        label: { type: String, default: 'Fichier' },
        type: { type: String, default: 'IMAGE' },
        preview: { type: String },
        required: { type: Boolean, default: false }
    });

    const allExtensionsInfos = {
        'ALL': {
            extensions_allowed: '',
            extensions_labels: 'Tous les fichiers'
        },
        'VIDEO': {
            extensions_allowed: '.mp4,.avi,.mov,.mkv',
            extensions_labels: 'MP4, MOV, AVI, MKV'
        },
        'IMAGE': {
            extensions_allowed: '.jpg,.jpeg,.png,.gif,.webp,.svg',
            extensions_labels: 'JPG, PNG, GIF, Webp, SVG'
        },
    };
    const extensionsAllowed = ref('');
    const extensionsLabels = ref('');
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });

    onMounted(() => {
        extensionsAllowed.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_allowed;
        extensionsLabels.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_labels;
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

</script>
<template>
    <label :for="props.id" class="custom-upload my-5" :class="{'active': formValue.file}"><!--active-->
        <div class="custom-upload-st2">
            <input :id="props.id" class="display-none" type="file" ref="fichier_photo" @change="onFileUploaded($event)" :accept="extensionsAllowed" />
            <div class="s5 custom-upload-img" style="background:url('/images/empty.png'); background-size:cover;">
                <img src="/icons/icon-idcard-recto.svg" width="45%" class="icon-white" />
            </div>
            <div class="s10">
                <span id="file-upload-title" class="custom-upload-text uppercase">{{ props.label }}</span> 
                <b class="color-danger" v-if="props.required">*</b>
                <br>
                <span id="file-upload-title" class="custom-upload-text-sm">{{ formValue.file_name ? formValue.file_name : "Charger l'image"}}</span>
            </div>
            <div class="s5 right"><img src="/icons/icon-upload.svg" class="custom-upload-icon" /></div>
        </div>
    </label>
</template>